// index-nav-grid.component.ts
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-index-nav-grid',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    MatButtonToggleModule
  ],
  templateUrl: './index-nav-grid.component.html',
  styleUrl: './index-nav-grid.component.scss'
})
export class IndexNavGridComponent implements OnInit {

  activeRoute: string = 'users';
  companyID: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.companyID = params['company'];
    });

    // Sync the toggle with current route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveRoute();
    });

    // Initial sync
    this.updateActiveRoute();
  }

  updateActiveRoute() {
    const url = this.router.url;
    if (url.includes('/index-users/')) {
      this.activeRoute = 'users';
    } else if (url.includes('/index-pages/')) {
      this.activeRoute = 'pages';
    } else if (url.includes('/index-platforms/')) {
      this.activeRoute = 'platforms';
    } else if (url.includes('/index-feeds/')) {
      this.activeRoute = 'feeds';
    }
  }

  onToggleChange(event: any) {
    this.activeRoute = event.value;

    // Navigate based on selection
    if (this.activeRoute === 'users') {
      this.router.navigate(['/manage-account/index-users/'+ this.companyID]);
    } else if (this.activeRoute === 'pages') {
      this.router.navigate(['/manage-account/index-pages/'+ this.companyID]);
    } else if (this.activeRoute === 'platforms') {
      this.router.navigate(['/manage-account/index-platforms/'+ this.companyID]);
    } else if (this.activeRoute === 'feeds') {
      this.router.navigate(['/manage-account/index-feeds/'+ this.companyID]);
    }
  }
}
